import { useState } from "react";
import { selectCommunicationData } from "../../store";
import { useAppSelector } from "../../store/hooks";
import { FileItemType } from "../../types/communication/communicationDataType";
import FotoMultiConfirmSection from "../foto-multi-confirm-section/FotoMultiConfirmSection";
import { LiqPhotoTypeMapper, PhotoTypeEnum } from "../../types/commonTypes";

const TOT_FOTO_PATENTE = 2

export interface FotoPatenteProps {
    onTotFotoIsRiched: any
}

/* istanbul ignore next */
const FotoPatente = ({ onTotFotoIsRiched }: FotoPatenteProps) => {
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    const [fotoPatente, setFotoPatente] = useState<FileItemType[]>(communication.fotoPatente)

    const numPhotos = fotoPatente?.length
    const leftLabelCmp = <p className="left-label-item">{`${numPhotos + 1} foto di ${TOT_FOTO_PATENTE}`}</p>

    const labelTxt = numPhotos === 0 ? 'Fronte' : 'Retro'
    const labelItem = <p className="mail-label">{labelTxt}</p>

    return (
        <FotoMultiConfirmSection
            fileType={PhotoTypeEnum.PATENTE_DOCS}
            additionalBeInfo={{
                liqDocumentType: LiqPhotoTypeMapper[PhotoTypeEnum.PATENTE_DOCS],
                liqDescription: "Patente"
            }}
            files={fotoPatente}
            setFiles={setFotoPatente}
            arrayDbPropSync={"fotoPatente"}
            textLabel={"Scatta foto"}
            titleImageDetail={"Foto patente"}
            leftLabelCmp={leftLabelCmp}
            mainLabelItem={labelItem}
            totPhotosForStepDone={TOT_FOTO_PATENTE}
            onTotFotoIsRiched={onTotFotoIsRiched}
        />
    )
}

export default FotoPatente